<template>
    <div>
        <div class="table-responsive content-vertionings table-size">
            <!-- <b-table striped hover bordered outlined :items="getVersionings" :fields="fieldsVersion" -->
            <!-- @row-clicked="displayVersioning"> -->
            <!-- </b-table> -->
            <table class="table table-hover  table-outlined">
                <thead>
                    <th>{{ $t("brandadmin.name") }}</th>
                    <th></th>
                </thead>
                <tbody>
                    <tr v-for="brand in getAllBrands">
                        <td class="table-title">{{ brand.name ? brand.name.toUpperCase() : "" }}</td>

                        <!-- <td  class="d-none d-md-block">4545454</td> -->
                        <td class="content-action">
                            <button class="btn" @click="accessFunctionality(brand);">{{ $t("brandadmin.access") }}</button>
                            <!-- </button> -->
                            <!-- <button class="btn" @click="removeVersioning(versioning)">{{$t('versioning.remove')}} -->
                            <!-- </button> -->
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    data() {
        return {};
    },
    computed: {
        ...mapGetters("brand", {
            getAllBrands: "getAllBrands"
        })
    },
    created() {
        this.findAllBrands();
    },
    mounted() {},
    methods: {
        ...mapActions("brand", {
            findAllBrands: "findAllBrands"
        }),

        accessFunctionality(brand) {
            this.$router.push("/admin/brandAccess/" + brand.id);
        }
    }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// BrandAdminList.vue?dd57628a